<template>
    <div>
        <SubTitle text="Administrar ordenes" class="left">
            <el-button v-on:click="openModal" size="small"
                    class="default right ml-1">
                BUSCAR SOC(s)
            </el-button>
        </SubTitle>

        <SuborderAdd ref="dialogAdd" v-model="list"/>
    </div>
</template>

<script>
import SubTitle from '../base/SubTitle.vue';
import SuborderAdd from '../planningv4/suborder/Add.vue';


export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      list: this.value,
    };
  },
  name: 'FindOrders',
  components: {
    SubTitle,
    SuborderAdd,
  },
  methods: {
    openModal() {
      this.$refs.dialogAdd.open();
    },
  },
  watch: {
    list() {
      this.$emit('input', this.list);
    },
    value() {
      this.list = this.value;
    },
  },
};

</script>

<style lang="scss" scoped>
.ml-1{
    margin-left:1rem;
}

.right{
    float:right
}
</style>
